import { Injectable, Injector } from "@angular/core";
import { BaseService } from "../base/base.service";
import { HttpClient } from "@angular/common/http";
import { PlatformLocation } from "@angular/common";
import { Observable } from "rxjs";
import { AppModulePath } from "app/models/app-module-path";
import { Document } from "app/models/document/document";
import { map, catchError } from "rxjs/operators";

@Injectable()
export class EotpremnicaServices extends BaseService {
  private syncUrl = "api/eotpremnica/customer/despatch-advices/by-esync-date";
  private syncPrijemnica = "api/eotpremnica/customer/receipt-advices/by-esync-date";


  constructor(
    protected injector: Injector,
    protected http2: HttpClient,
    protected platformLocation: PlatformLocation,
  ) {
    super(injector, http2, platformLocation);
  }

  syncFromEuprava(): Observable<Document[]> {
    return this.get<Document[]>(
      this.syncUrl,
      AppModulePath.ULAZNA_OTPREMNICA,
    ).pipe(catchError(this.handleError));
  }

   syncReceiptAdvice(): Observable<Document[]> {
    return this.get<Document[]>(
      this.syncPrijemnica,
      AppModulePath.ULAZNA_PRIJEMNICA,
    ).pipe(catchError(this.handleError));
  }

  retryResolveDocumentItems(documentEid: string): Observable<void> {
    return this.post<void>(
      `/api/eotpremnica/customer/documents/${documentEid}/retry-items`,
      AppModulePath.ULAZNA_OTPREMNICA,
      null,
    ).pipe(catchError(this.handleError));
  }

  downloadIncomingDespatchAdvicePdf(documentEid: string): Observable<Blob> {
    return this.get<Blob>(
      `/api/eotpremnica/customer/despatch-advices/${documentEid}/pdf`,
      AppModulePath.ULAZNA_OTPREMNICA,
      { responseType: "blob" as "json" },
    ).pipe(
      map((res) => new Blob([res as BlobPart], { type: "application/pdf" })),
      catchError(this.handleError),
    );
  }

  downloadReceiptAdvicePdf(
    documentEid: string,
    appModulePath: string = AppModulePath.PRIJEMNICA,
  ): Observable<Blob> {
    return this.get<Blob>(
      `/api/eotpremnica/customer/receipt-advices/${documentEid}/pdf`,
      appModulePath,
      { responseType: "blob" as "json" },
    ).pipe(
      map((res) => new Blob([res as BlobPart], { type: "application/pdf" })),
      catchError(this.handleError),
    );
  }

  downloadSupplierReceiptAdvicePdf(documentEid: string): Observable<Blob> {
    return this.get<Blob>(
      `/api/eotpremnica/suppliers/receipt-advices/${documentEid}/pdf`,
      AppModulePath.ULAZNA_PRIJEMNICA,
      { responseType: "blob" as "json" },
    ).pipe(
      map((res) => new Blob([res as BlobPart], { type: "application/pdf" })),
      catchError(this.handleError),
    );
  }

  recoverEid(documentId: string): Observable<any> {
    return this.post<any>(
      `/api/document/recoverEid/${documentId}`,
      AppModulePath.PRIJEMNICA,
      null,
    ).pipe(catchError(this.handleError));
  }

  acceptReceiptAdvice(documentId: string): Observable<any> {
    return this.post<any>(
      `/api/eotpremnica/customer/receipt-advices/${documentId}/accept`,
      AppModulePath.ULAZNA_PRIJEMNICA,
      null,
    ).pipe(catchError(this.handleError));
  }

  rejectReceiptAdvice(documentId: string): Observable<any> {
    return this.post<any>(
      `/api/eotpremnica/customer/receipt-advices/${documentId}/reject`,
      AppModulePath.ULAZNA_PRIJEMNICA,
      null,
    ).pipe(catchError(this.handleError));
  }
}
